import React, { Component } from 'react';
import Social from '../blocks/Social';
import TwitterFeed from '../blocks/TwitterFeed';
import { LOCATION } from '../../utils/Constants';


class Footer extends Component {
  componentDidMount(){

  }
  render(){

    return(
      <footer>
        <div className="row">
          <div className="medium-4 columns">
          <h3 className="footer-heading no-margin">Other areas in Essex</h3>
            <ul className="footer-list">
              <li><a href="http://www.canveyislandonline.com/" rel="noopener noreferrer" target="_blank">Canvey Island Online</a></li>
            </ul>
            <br/>
            <h3 className="footer-heading no-margin">Other useful sites to visit</h3>
            <ul className="footer-list">
              <li><a href="http://www.basildon.gov.uk" rel="noopener noreferrer" target="_blank">Basildon Council</a></li>
              <li><a href="http://www.bbwcvs.org.uk/" rel="noopener noreferrer" target="_blank">Basildon, Billericay & Wickford CVS</a></li>
              <li><a href="http://www.basildon.com/" rel="noopener noreferrer" target="_blank">Basildon.com</a></li>
            </ul>
            
          </div>
          <div className="medium-4 columns twitter-feed">
            
            <TwitterFeed
              tweets={this.props.tweets}
            />
            
          </div>
          <div className="medium-4 columns footer-social">
            <Social/>

            <p>&copy; 2018 A <a href="http://www.winkletwebdesign.com" rel="noopener noreferrer" target="_blank">Winklet Web Design</a> website</p>
            <p><a href="/sitemap">Sitemap</a></p>
          </div>
          
        </div>
        
      </footer>
    );
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/components/sections/Footer.js